import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'demo-upp-color',
    templateUrl: './demo-upp-color.html',
    styleUrls: ['../demo-common.scss', './demo-upp-color.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppColorComponent {
    bgColor = '5663ff';
    fgColor = 'ffffff';

    constructor(private change: ChangeDetectorRef) {
    }

    OnBackgroundChanged(value: string | null): void {
        this.bgColor = String(value || '');
        this.change.markForCheck();
    }

    OnForegroundChanged(value: string | null): void {
        this.fgColor = String(value || '');
        this.change.markForCheck();
    }

    get BackgroundPreview(): string {
        return `#${this.bgColor.padEnd(6, '0').slice(0, 6)}`;
    }

    get ForegroundPreview(): string {
        return `#${this.fgColor.padEnd(6, '0').slice(0, 6)}`;
    }
}
